import React from 'react'

import { datatableTypes } from '@/typings'

import DatatableMobileSortItem from './DatatableMobileSortItem'

type Props = {
	cols: datatableTypes.DatatableCol[]
}

const DatatableMobileSort = ({ cols }: Props) => {
	return (
		<div className="mb-4">
			{cols
				.filter(({ sort = true, ...rest }) => ({ ...rest, sort }))
				.map((item, i) => (
					<DatatableMobileSortItem key={item.dataKey} dataKey={item.dataKey} last={cols.length - 1 === i}>
						{item.title}
					</DatatableMobileSortItem>
				))}
		</div>
	)
}

export default DatatableMobileSort
